<template>
	<card title="Muestras Despachadas" bg="bg-dark text-white">
		<!--<div style="height: 40px; width: 100%;" v-if="details.length > 0">
      <button @click="confirm" class="btn btn-success btn-block"><i class="fas fa-check-double"></i> Confirmar</button>
    </div>-->
		<card v-if="progressDispatch == 'No'" title="Tracking">
			<div class="table-responsive">
				<table class="table table-striped table-bordered">
					<thead class="thead-light">
						<tr>
							<th>Courier</th>
							<th style="width: 250px">Fecha Despacho</th>
							<th>N° Seguimiento</th>
							<th>N° Guía</th>
							<th style="width: 210px">Link</th>
						</tr>
						<tr v-for="t in tracking" :key="t.id">
							<td v-if="t.requestCommercialSampleDetailId == details[0].id">
								{{ t.courier }}
							</td>
							<td style="max-width: 80px" v-if="t.requestCommercialSampleDetailId == details[0].id">
								{{ t.shippingDateCourierString }}
							</td>
							<td v-if="t.requestCommercialSampleDetailId == details[0].id">
								{{ t.trackingNumber }}
							</td>
							<td v-if="t.requestCommercialSampleDetailId == details[0].id">
								{{ t.transportDispatchGuide }}
							</td>
							<td v-if="t.requestCommercialSampleDetailId == details[0].id">
								<a class="btn btn-warning" :href="t.trackingUrl" target="_blank">
									<b>Ver Seguimiento</b>
									<i class="fas fa-truck ml-2"></i>
								</a>
							</td>
						</tr>
					</thead>
				</table>
			</div>
		</card>
		<card v-if="detailNew.length > 0" title="Nuevo Producto">
			<div class="table-responsive">
				<div v-for="item in detailNew" :key="item.id">
					<div class="card mb-4 cardShadow">
						<span>
							<div :class="item.statusColor">
								<span>{{ item.status }}</span>
							</div>
						</span>
						<div class="card-body">
							<div class="row">
								<div class="col-md-12">
									<table class="table table-striped table-hover table-bordered">
										<thead class="thead-dark">
											<tr>
												<th>Marca</th>
												<th>Mezcla Comercial</th>
												<th>Vino</th><th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
												<th>Botellas</th>
												<th v-if="item.status == 'Por Despachar' &&
													progressDispatch == 'Si'
													">
													Opciones
												</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>{{ item.brand }}</td>
												<th v-if="r.comercialMixCode">
													{{ r.comercialMixCode }} {{ r.comercialMix }}
												</th>
												<td>
													{{ item.variety }}
													{{ item.valley }} {{ item.quality }}
												</td>
												<td>{{ item.finalHarvest }}</td><td>{{ item.quantity }}</td>
												<td v-if="item.status == 'Por Despachar' &&
													progressDispatch == 'Si'
													">
													<b-form-checkbox @change="SampleList(item.id, item.rejectionReason)"
														name="check-button" switch class="mt-2">Despachado</b-form-checkbox>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="card mb-4 bg-danger" v-if="item.status == 'Desp. Rechazado'">
								<div class="card-body">
									<span class="text-white"><b>Motivo de rechazo: </b> {{ item.rejectionReason }}</span>
								</div>
							</div>
							<div class="card mb-4 bg-danger" v-if="item.rejectionWineryDispatchReason">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo:</b>
										{{ item.rejectionWineryDispatchReason }}
									</span>
								</div>
							</div>
							<div class="card mb-4 bg-danger" v-if="item.cancelledReason">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo Cancelación:</b> {{ item.cancelledReason }}
									</span>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<a style="width: 100%" class="btn btn-primary" data-toggle="collapse"
										:href="'#collapse' + item.id" role="button" aria-expanded="false"
										:aria-controls="'collapse' + item.id">
										Componentes
										<i class="fas fa-angle-down ml-4"></i>
									</a>
								</div>
								<div v-if="item.status == 'Despachado' && progressDispatch == 'Si'" class="col-md-6">
									<a style="width: 100%" class="btn btn-primary" data-toggle="collapse"
										:href="'#collapseTracking' + item.id" role="button" aria-expanded="false"
										:aria-controls="'collapseTracking' + item.id">
										Tracking
										<i class="fas fa-angle-down ml-4"></i>
									</a>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<div class="collapse multi-collapse" :id="'collapse' + item.id">
										<table class="table table-bordered">
											<thead class="thead-light">
												<tr>
													<th>Capsula</th>
													<td>
														{{ item.capsuleName }} - {{ item.capsuleCode }}
													</td>
												</tr>
												<tr>
													<th>Tapa</th>
													<td>
														{{ item.cappingName }} - {{ item.cappingCode }}
													</td>
												</tr>
												<tr>
													<th>Caja</th>
													<td>{{ item.boxName }} - {{ item.boxCode }}</td>
												</tr>
												<tr>
													<th>Botella</th>
													<td>{{ item.bottleName }} - {{ item.bottleCode }}</td>
												</tr>
											</thead>
										</table>
									</div>
								</div>
								<div v-if="tracking" class="col-md-6 collapse multi-collapse"
									:id="'collapseTracking' + item.id">
									<div v-for="t in tracking" :key="t.id">
										<table class="table table-striped table-hover table-bordered"
											v-if="t.requestCommercialSampleDetailId == item.id">
											<thead class="thead-light">
												<tr>
													<th style="width: 200px">Courier</th>
													<td>{{ t.courier }}</td>
												</tr>
												<tr>
													<th>Fecha Despacho</th>
													<td>{{ t.shippingDateCourierString }}</td>
												</tr>
												<tr>
													<th>N° Seguimiento</th>
													<td>{{ t.trackingNumber }}</td>
												</tr>
												<tr>
													<th>N° Guía</th>
													<td>{{ t.transportDispatchGuide }}</td>
												</tr>
												<tr>
													<th colspan="2">
														<a style="width: 100%" class="btn btn-warning" :href="t.trackingUrl"
															target="_blank"><b>Ver Seguimiento</b><i
																class="fas fa-truck ml-2"></i></a>
													</th>
												</tr>
											</thead>
										</table>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="3">Observaciones Adicionales</th>
											</tr>
											<tr v-if="item.requestDetailObservations">
												<th style="width: 18%">Fecha</th>
												<th style="width: 12%">Usuario</th>
												<th style="width: 70%">Observación</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="observation in item.requestDetailObservations" :key="observation.id">
												<td>{{ observation.createdAtString }}</td>
												<td>{{ observation.email }}</td>
												<td>{{ observation.observation }}</td>
											</tr>
											<tr>
												<td colspan="3">
													<div class="row">
														<div class="col-10">
															<input class="form-control" :id="'observation-input-' + item.id" type="text" />
														</div>
														<div class="col-2">
															<button class="btn btn-success float-right" @click="addObservation(item.id)">
																<i class="fa fa-save"></i>
																<span class="ml-2">Registrar Observación</span>
															</button>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<table class="table table-stripped table-hover table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="5">Documentos Adjuntos</th>
											</tr>
											<tr v-if="item.documentFiles.length > 0">
												<th style="width: 18%">Usuario</th>
												<th style="width: 12%">Fecha de Carga</th>
												<th style="width: 54%">Nombre del Archivo</th>
												<th style="width: 8%">Tipo de Archivo</th>
												<th style="width: 8%">Opciones</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="doc in item.documentFiles" :key="doc.id">
												<td>{{ doc.email }}</td>
												<td>{{ doc.createdAtString }}</td>
												<td>{{ doc.fileName }}</td>
												<td style="font-size: 20px">
													<span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
															class="fas fa-file-pdf" aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.jpg' ||
														doc.fileExtension == '.png'
														" class="text-info"><i class="fas fa-image" aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.xls' ||
														doc.fileExtension == '.xlsx'
														" class="text-success"><i class="fas fa-file-excel" aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.doc' ||
														doc.fileExtension == '.docx'
														" class="text-primary"><i class="fas fa-file-word"></i></span>
												</td>
												<td>
													<button class="btn btn-sm btn-success mr-2"
														@click="downloadFile(doc.id)">
														<i class="fa fa-download"></i>
													</button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</card>
		<card v-if="detailFinish.length > 0" title="Producto Terminado">
			<div class="table-responsive">
				<div v-for="item in detailFinish" :key="item.id">
					<div class="card mb-4 cardShadow">
						<span>
							<div :class="item.statusColor">
								<span>{{ item.status }}</span>
							</div>
						</span>
						<div class="card-body">
							<table class="table table-striped table-hover table-bordered">
								<thead class="thead-dark">
									<tr>
										<th>Sku</th>
										<th>Marca</th>
										<th>Vino</th><th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
										<th>Botellas</th>
										<th v-if="item.status == 'Por Despachar' &&
											progressDispatch == 'Si'
											">
											Opciones
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{{ item.sku }}</td>
										<td>{{ item.brand }}</td>
										<td>
											{{ item.variety }} {{ item.valley }}
											{{ item.quality }}
										</td>
										<td>{{ item.finalHarvest }}</td><td>{{ item.quantity }}</td>
										<td v-if="item.status == 'Por Despachar' &&
											progressDispatch == 'Si'
											">
											<b-form-checkbox @change="SampleList(item.id)" name="check-button" switch
												class="mt-2">Despachado</b-form-checkbox>
										</td>
									</tr>
								</tbody>
							</table>
							<div class="card mb-4 bg-danger" v-if="item.rejectionReason">
								<div class="card-body">
									<span class="text-white"><b>Motivo de rechazo: </b> {{ item.rejectionReason }}</span>
								</div>
							</div>
							<div class="card mb-4 bg-danger" v-if="item.status == 'Invalidado'">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo:</b>
										{{ item.rejectionWineryDispatchReason }}
									</span>
								</div>
							</div>
							<div class="card mb-4 bg-danger" v-if="item.cancelledReason">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo Cancelación:</b> {{ item.cancelledReason }}
									</span>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<a style="width: 100%" class="btn btn-primary" data-toggle="collapse"
										:href="'#collapse' + item.id" role="button" aria-expanded="false"
										:aria-controls="'collapse' + item.id">
										Componentes
										<i class="fas fa-angle-down ml-4"></i>
									</a>
								</div>
								<div v-if="item.status == 'Despachado' && progressDispatch == 'Si'" class="col-md-6">
									<a style="width: 100%" class="btn btn-primary" data-toggle="collapse"
										:href="'#collapseTracking' + item.id" role="button" aria-expanded="false"
										:aria-controls="'collapseTracking' + item.id">
										Tracking
										<i class="fas fa-angle-down ml-4"></i>
									</a>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<div class="collapse multi-collapse" :id="'collapse' + item.id">
										<table class="table table-striped table-hover table-bordered">
											<tr v-if="item.saleZoneCode != null">
												<th>
													Zona de venta:
													<span class="ml-2">{{ item.saleZoneCode }}</span>
												</th>
											</tr>
											<tr v-for="lc in item.components" :key="lc.id">
												<td v-if="lc.requestCommercialSampleDetailId === item.id">
													{{ lc.name }}
												</td>
											</tr>
										</table>
									</div>
								</div>
								<div v-if="tracking" class="col-md-6 collapse multi-collapse"
									:id="'collapseTracking' + item.id">
									<div v-for="t in tracking" :key="t.id">
										<table class="table table-striped table-hover table-bordered"
											v-if="t.requestCommercialSampleDetailId == item.id">
											<thead class="thead-light">
												<tr>
													<th style="width: 200px">Courier</th>
													<td>{{ t.courier }}</td>
												</tr>
												<tr>
													<th>Fecha Despacho</th>
													<td>{{ t.shippingDateCourierString }}</td>
												</tr>
												<tr>
													<th>N° Seguimiento</th>
													<td>{{ t.trackingNumber }}</td>
												</tr>
												<tr>
													<th>N° Guía</th>
													<td>{{ t.transportDispatchGuide }}</td>
												</tr>
												<tr>
													<th colspan="2">
														<a style="width: 100%" class="btn btn-warning" :href="t.trackingUrl"
															target="_blank">
															<b>Ver Seguimiento</b>
															<i class="fas fa-truck ml-2"></i>
														</a>
													</th>
												</tr>
											</thead>
										</table>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="3">Observaciones Adicionales</th>
											</tr>
											<tr v-if="item.requestDetailObservations">
												<th style="width: 18%">Fecha</th>
												<th style="width: 12%">Usuario</th>
												<th style="width: 70%">Observación</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="observation in item.requestDetailObservations" :key="observation.id">
												<td>{{ observation.createdAtString }}</td>
												<td>{{ observation.email }}</td>
												<td>{{ observation.observation }}</td>
											</tr>
											<tr>
												<td colspan="3">
													<div class="row">
														<div class="col-10">
															<input class="form-control" :id="'observation-input-' + item.id" type="text" />
														</div>
														<div class="col-2">
															<button class="btn btn-success float-right" @click="addObservation(item.id)">
																<i class="fa fa-save"></i>
																<span class="ml-2">Registrar Observación</span>
															</button>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<table class="table table-stripped table-hover table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="5">Documentos Adjuntos</th>
											</tr>
											<tr v-if="item.documentFiles.length > 0">
												<th style="width: 18%">Usuario</th>
												<th style="width: 12%">Fecha de Carga</th>
												<th style="width: 54%">Nombre del Archivo</th>
												<th style="width: 8%">Tipo de Archivo</th>
												<th style="width: 8%">Opciones</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="doc in item.documentFiles" :key="doc.id">
												<td>{{ doc.email }}</td>
												<td>{{ doc.createdAtString }}</td>
												<td>{{ doc.fileName }}</td>
												<td style="font-size: 20px">
													<span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
															class="fas fa-file-pdf" aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.jpg' ||
														doc.fileExtension == '.png'
														" class="text-info"><i class="fas fa-image" aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.xls' ||
														doc.fileExtension == '.xlsx'
														" class="text-success"><i class="fas fa-file-excel" aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.doc' ||
														doc.fileExtension == '.docx'
														" class="text-primary"><i class="fas fa-file-word"></i></span>
												</td>
												<td>
													<button class="btn btn-sm btn-success mr-2"
														@click="downloadFile(doc.id)">
														<i class="fa fa-download"></i>
													</button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</card>
		<card v-if="detailBottle.length > 0" title="Producto Guarda Botella">
			<div class="table-responsive">
				<div v-for="item in detailBottle" :key="item.id">
					<div class="card mb-4 cardShadow">
						<span>
							<div :class="item.statusColor">
								<span>{{ item.status }}</span>
							</div>
						</span>
						<div class="card-body">
							<table class="table table-striped table-hover table-bordered">
								<thead class="thead-dark">
									<tr>
										<th>Código</th>
										<th>Marca</th>
										<th>Vino</th><th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
										<th>Botellas</th>
										<th v-if="item.status == 'Por Despachar' &&
											progressDispatch == 'Si'
											">
											Opciones
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{{ item.sku }}</td>
										<td>{{ item.brand }}</td>
										<td>
											{{ item.variety }} {{ item.valley }}
											{{ item.quality }}
										</td>
										<td>{{ item.finalHarvest }}</td><td>{{ item.quantity }}</td>
										<td v-if="item.status == 'Por Despachar' &&
											progressDispatch == 'Si'
											">
											<b-form-checkbox @change="SampleList(item.id)" name="check-button" switch
												class="mt-2">Despachado</b-form-checkbox>
										</td>
									</tr>
								</tbody>
							</table>
							<div class="card mb-4 bg-danger" v-if="item.rejectionReason">
								<div class="card-body">
									<span class="text-white"><b>Motivo de rechazo: </b> {{ item.rejectionReason }}</span>
								</div>
							</div>
							<div class="card mb-4 bg-danger" v-if="item.rejectionWineryDispatchReason">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo:</b>
										{{ item.rejectionWineryDispatchReason }}
									</span>
								</div>
							</div>
							<div class="card mb-4 bg-danger" v-if="item.cancelledReason">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo Cancelación:</b> {{ item.cancelledReason }}
									</span>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<a style="width: 100%" class="btn btn-primary" data-toggle="collapse"
										:href="'#collapse' + item.id" role="button" aria-expanded="false"
										:aria-controls="'collapse' + item.id">
										Componentes
										<i class="fas fa-angle-down ml-4"></i>
									</a>
								</div>
								<div v-if="item.status == 'Despachado' && progressDispatch == 'Si'" class="col-md-6">
									<a style="width: 100%" class="btn btn-primary" data-toggle="collapse"
										:href="'#collapseTracking' + item.id" role="button" aria-expanded="false"
										:aria-controls="'collapseTracking' + item.id">
										Tracking
										<i class="fas fa-angle-down ml-4"></i>
									</a>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<div class="collapse multi-collapse" :id="'collapse' + item.id">
										<table class="table table-striped table-hover table-bordered">
											<tr v-for="lc in item.components" :key="lc.id">
												<td v-if="lc.requestCommercialSampleDetailId === item.id">
													{{ lc.name }}
												</td>
											</tr>
										</table>
									</div>
								</div>
								<div v-if="tracking" class="col-md-6 collapse multi-collapse"
									:id="'collapseTracking' + item.id">
									<div v-for="t in tracking" :key="t.id">
										<table class="table table-striped table-hover table-bordered"
											v-if="t.requestCommercialSampleDetailId == item.id">
											<thead class="thead-light">
												<tr>
													<th style="width: 200px">Courier</th>
													<td>{{ t.courier }}</td>
												</tr>
												<tr>
													<th>Fecha Despacho</th>
													<td>{{ t.shippingDateCourierString }}</td>
												</tr>
												<tr>
													<th>N° Seguimiento</th>
													<td>{{ t.trackingNumber }}</td>
												</tr>
												<tr>
													<th>N° Guía</th>
													<td>{{ t.transportDispatchGuide }}</td>
												</tr>
												<tr>
													<th colspan="2">
														<a style="width: 100%" class="btn btn-warning" :href="t.trackingUrl"
															target="_blank">
															<b>Ver Seguimiento</b>
															<i class="fas fa-truck ml-2"></i>
														</a>
													</th>
												</tr>
											</thead>
										</table>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="3">Observaciones Adicionales</th>
											</tr>
											<tr v-if="item.requestDetailObservations">
												<th style="width: 18%">Fecha</th>
												<th style="width: 12%">Usuario</th>
												<th style="width: 70%">Observación</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="observation in item.requestDetailObservations" :key="observation.id">
												<td>{{ observation.createdAtString }}</td>
												<td>{{ observation.email }}</td>
												<td>{{ observation.observation }}</td>
											</tr>
											<tr>
												<td colspan="3">
													<div class="row">
														<div class="col-10">
															<input class="form-control" :id="'observation-input-' + item.id" type="text" />
														</div>
														<div class="col-2">
															<button class="btn btn-success float-right" @click="addObservation(item.id)">
																<i class="fa fa-save"></i>
																<span class="ml-2">Registrar Observación</span>
															</button>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<table class="table table-stripped table-hover table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="5">Documentos Adjuntos</th>
											</tr>
											<tr v-if="item.documentFiles.length > 0">
												<th style="width: 18%">Usuario</th>
												<th style="width: 12%">Fecha de Carga</th>
												<th style="width: 54%">Nombre del Archivo</th>
												<th style="width: 8%">Tipo de Archivo</th>
												<th style="width: 8%">Opciones</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="doc in item.documentFiles" :key="doc.id">
												<td>{{ doc.email }}</td>
												<td>{{ doc.createdAtString }}</td>
												<td>{{ doc.fileName }}</td>
												<td style="font-size: 20px">
													<span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
															class="fas fa-file-pdf" aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.jpg' ||
														doc.fileExtension == '.png'
														" class="text-info"><i class="fas fa-image" aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.xls' ||
														doc.fileExtension == '.xlsx'
														" class="text-success"><i class="fas fa-file-excel" aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.doc' ||
														doc.fileExtension == '.docx'
														" class="text-primary"><i class="fas fa-file-word"></i></span>
												</td>
												<td>
													<button class="btn btn-sm btn-success mr-2"
														@click="downloadFile(doc.id)">
														<i class="fa fa-download"></i>
													</button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</card>
	</card>
</template>
<script>
import { Post } from "../../../helper/axios";
export default {
	props: ["details", "id", "components", "progressDispatch", "tracking"],
	data() {
		return {
			Post,
			apiUrl: this.$store.getters.apiUrl,
			detailId: 0,
			listSelectSample: [],
			exist: false,
			updateDispatch: {},
			rejectionReason: "",
		};
	},
	methods: {
		confirm() {
			this.$swal({
				title: "¿Desea Confirmar Recepción de Despacho?",
				icon: "info",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
			}).then((result) => {
				if (result.value) {
					this.$store.commit("setLoading", true);
					this.Post(
						`${this.apiUrl}v1/requestsample/${this.id}/confirm`,
						{},
						() => {
							this.$store.commit("setLoading", false);
							window.toastr.success("Se ha confirmado correctamente.");
							//this.$router.push("/");
							location.reload();
						}
					);
				}
			});
		},
		getRequest() {
			this.$store.commit("setLoading", true);
			this.Get(this.apiUrl + "v1/requestsamples/", (res) => {
				this.requests = res.data;
				this.$store.commit("setLoading", false);
			});
		},
		downloadFile(id) {
			window.open(`${this.apiUrl}v1/documentfile/${id}`);
		},
		addObservation(detailId) {
			this.$store.commit("setLoading", true);
			let obs = document.getElementById("observation-input-" + detailId);
			let data = {
				requestCommercialSampleDetailId: detailId,
				observation: obs.value
			};
			this.Post(`${this.apiUrl}v1/RequestDetailObservations`, data, () => {
				this.$store.commit("setLoading", false);
				window.toastr.success("Se ha registrado la Observación correctamente.");
				obs.value = '';
				this.$emit("updateObservations");
			});
		},
	},
	computed: {
		detailNew: function () {
			return this.details.filter((x) => x.requestTypeId === 1);
		},
		detailFinish: function () {
			return this.details.filter((x) => x.requestTypeId === 2);
		},
		detailBottle: function () {
			return this.details.filter((x) => x.requestTypeId === 3);
		},
	},
};
</script>